import styled from "styled-components";
import { Card } from "../../../components/ui/card/card.component";
import { colors } from "../../../theme/colors";
import { Column } from "../../../components/ui/grid/column.component";
import { LinkingAlert } from "../../../models/linking-alert.model";
import { useNavigate } from "react-router-dom";

export const Alert = ({ alert }: { alert: LinkingAlert }) => {
  const navigate = useNavigate();

  return (
    <Main onClick={() => navigate("/p")}>
      <ProfilePicture />
      <Column style={{ alignItems: "flex-start" }}>
        <Title>
          {alert.film_title} - {alert.type}
        </Title>
        <Description>Linking request</Description>
      </Column>
    </Main>
  );
};

const Main = styled(Card)`
  display: flex;
  align-items: center;
  padding: 1.5rem 2.5rem;
  border-radius: 0.5rem;
  gap: 1rem;
  cursor: pointer;
  min-width: min(100%, 25rem);
  max-width: 100%;
`;

const ProfilePicture = styled.img.attrs({
  src: "/images/ui/avatar.png",
})`
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  border: 2px solid ${colors.complement.hex};
`;

const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
`;

const Description = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
`;
